import React from 'react';
// plusicon, refreshicon,
import { searchnormal } from '../../imagepath';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import SearchInput from '../../Forms/SearchInput';
import { Col, Row, Tooltip, Button, Select,Checkbox } from 'antd';
const { Option } = Select;

const ListTableToolbar = ({ onAdd, onSearch, onRefresh, hideAddAction, addActionTooltipTitle ,showStatusFilter = false, onStatusChange = () => {}, showHasStatusFilter = false, hasRushFilterChecked = false, onhasRushStatusChange = () => {} }) => {
  return (
    <div className="page-table-header mb-2">
      <div className="row align-items-center">
        <div className="col">
          <div className="doctor-table-blk">
            <Row gutter={[16, 16]} wrap>
              <Col>
                <div className="doctor-search-blk">
                  <div className="top-nav-search table-search-blk">
                    <form>
                      <SearchInput
                        className="form-control"
                        onSearchChange={onSearch}
                      />
                      <Link className="btn">
                        <img src={searchnormal} alt="#" />
                      </Link>
                    </form>
                  </div>
                  {/* ✅ Conditionally show Paid/Unpaid menu */}
                  <div className="add-group">
                  {showStatusFilter && (
                    <Select
                      style={{ width: 150, marginRight: 10 }}
                      onChange={(value) => {
                        // When cleared (value is undefined/null), show all records
                        onStatusChange(value || 'all');
                      }}
                      allowClear
                      placeholder="Select Status"
                      className='ms-2'
                    >
                      <Option value="paid">Paid</Option>
                      <Option value="unpaid">Unpaid</Option>
                    </Select>
                  )}
                  </div>
                  <div className="add-group">
                    {showHasStatusFilter && (
                      <Checkbox
                        className="ms-2"
                        checked={hasRushFilterChecked}
                        onChange={(e) => onhasRushStatusChange(e.target.checked)}
                      >
                        Rush Only
                      </Checkbox>
                    )}

                  </div>
                  <div className="add-group">
                    {!hideAddAction ? (
                      <Tooltip title={addActionTooltipTitle || 'Add New'}>
                        <Button
                          type="primary"
                          onClick={(e) => {
                            e?.preventDefault();
                            onAdd();
                          }}
                          className="ms-2"
                        >
                          ADD
                          {/* <img src={plusicon} alt="#" /> */}
                        </Button>
                      </Tooltip>
                    ) : null}
                    <Tooltip title={'Refresh List'}>
                      <Button
                        onClick={(e) => {
                          e?.preventDefault();
                          onRefresh();
                        }}
                        className="ms-2"
                      >
                        Refresh
                      </Button>
                    </Tooltip>
                    {/* {extra} */}
                  </div>
                </div>
              </Col>
              {/* <Col>
                <div className="add-group">
                  {!hideAddAction ? (
                    <Tooltip title={addActionTooltipTitle || 'Add New'}>
                      <Link
                        onClick={(e) => {
                          e?.preventDefault();
                          onAdd();
                        }}
                        className="btn btn-primary add-pluss"
                      >
                        <img src={plusicon} alt="#" />
                      </Link>
                    </Tooltip>
                  ) : null}
                  <Link
                    onClick={(e) => {
                      e?.preventDefault();
                      onRefresh();
                    }}
                    className="btn btn-primary doctor-refresh ms-2"
                  >
                    <img src={refreshicon} alt="#" />
                  </Link>
                </div>
              </Col> */}
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

ListTableToolbar.propTypes = {
  onAdd: PropTypes.func,
  onSearch: PropTypes.func,
  onRefresh: PropTypes.func,
  hideAddAction: PropTypes.bool,
  addActionTooltipTitle: PropTypes.string,
  showStatusFilter: PropTypes.bool,   // ✅
  onStatusChange: PropTypes.func,     // ✅
  showHasStatusFilter: PropTypes.bool,
  hasRushFilterChecked: PropTypes.bool,
  onhasRushStatusChange: PropTypes.func,
};

export default ListTableToolbar;
